const VISA_NETWORK = 1
const MASTERCARD_NETWORK = 3
const LEGACY_MASTERCARD_NETWORK = 2

export const getPrivateCardNetworkCounts = (cards: Array<Pick<ICardSaved, "network">>) => {
	const visa = cards.filter(card => card.network === VISA_NETWORK).length
	const mastercard = cards.filter(card => card.network === MASTERCARD_NETWORK || card.network === LEGACY_MASTERCARD_NETWORK).length
	return { visa, mastercard, other: cards.length - visa - mastercard }
}
